export const stepsForRenewOffer = ['Creation', 'Sent', 'Viewed', 'Accepted']

export type RenewOfferSubscriptionProps = {
  externalBaseURL?: string
  search?: string
  crmOpportunityId?: string
  crmObjectLink?: string
  isSalesforce?: boolean
  steps?: string[]
}
